import { useGetWaitingRoomDoctorsQuery, useGetWaitingRoomQuery } from '@/core/services/waiting-room'

export function useRefresh(waitingRoomId: string) {
  const { refetch: refetchWaitingRoom } = useGetWaitingRoomQuery(waitingRoomId, { refetchOnMountOrArgChange: true })
  const { refetch: refetchDoctors } = useGetWaitingRoomDoctorsQuery(waitingRoomId, { refetchOnMountOrArgChange: true })

  const refresh = () => {
    refetchWaitingRoom()
    refetchDoctors()
  }

  return refresh
}
